import { useMemo, useRef, useCallback, createContext, useEffect } from 'react';

export const MouseAvailabilityContext = createContext();

export default function MouseAvailabilityProvider({children}){

  const mouseAvailability = useRef(true);
  const mouseFocusController = useRef();

  const isMouseAvailable = useCallback(() => {
    let availability = mouseAvailability.current;
    //console.log("currentMouseController => " + mouseFocusController.current);
    return availability;
  },[])

  const requestMouseFocus = useCallback((mouseFocusControllerId) => {
    if( !mouseFocusController ){
      throw Error("Cannot request mouse foucs without providing a controller id.");
    }
    if( isMouseAvailable() ){
      mouseAvailability.current = false;
      mouseFocusController.current = mouseFocusControllerId;
      return true;
    }
    return false;
  },[isMouseAvailable])

  const releaseMouseFocus = useCallback((mouseFocusControllerId) => {
    if( mouseFocusController.current === mouseFocusControllerId ){
      mouseAvailability.current = true;
      mouseFocusController.current = undefined;
    }
  },[])

  useEffect(() => {
    const onMouseUp = () => mouseAvailability.current = true;
    window.addEventListener('mouseup',onMouseUp);
    return () => {
      window.removeEventListener('mouseup',onMouseUp);
    }
  },[])


  const value = useMemo(() => ({
    isMouseAvailable,
    requestMouseFocus,
    releaseMouseFocus
  }),[isMouseAvailable,requestMouseFocus,releaseMouseFocus])

  return (
    <MouseAvailabilityContext.Provider value={value}>
      {children}
    </MouseAvailabilityContext.Provider>

  )
}
